import AtMentionsViewState from '../store/schema/AtMentionsViewState';
import RecipientWellWithFindControlViewState from 'owa-recipient-types/lib/types/RecipientWellWithFindControlViewState';
import FindRecipientPersonaType from 'owa-recipient-types/lib/types/FindRecipientPersonaType';
import { action } from 'satcheljs/lib/legacy';
import addRecipientsToRecipientWell from 'owa-recipient-common/lib/actions/addRecipientsToRecipientWell';
import { getReadWriteRecipientViewStateFromFindRecipientPersonaType } from 'owa-recipient-create-viewstate/lib/util/getReadWriteRecipientViewStateFromFindRecipientPersonaType';

export default action('addSelectedRecipientToWell')(function addSelectedRecipientToWell(
    viewState: AtMentionsViewState,
    targetRecipientWell: RecipientWellWithFindControlViewState,
    newPersona: FindRecipientPersonaType = null
) {
    if (!newPersona) {
        newPersona = viewState.findResultSet[viewState.selectedRecipientIndex];
    }

    addRecipientsToRecipientWell(
        [getReadWriteRecipientViewStateFromFindRecipientPersonaType(newPersona)],
        targetRecipientWell
    );
});
